import { CircleCheckIcon, FileTextIcon, GraduationCapIcon, MessageSquareIcon, StarIcon } from "lucide-react";

export const processSteps = [
  {
    icon: MessageSquareIcon,
    title: { en: "Free Consultation", es: "Consulta Gratis" },
    text: { en: "Contact us to discuss your needs. A no-obligation conversation to understand your business requirements.", es: "Contáctenos para hablar de sus necesidades. Una consulta sin compromiso para entender su negocio." },
    time: { en: "15–30 minutes", es: "15–30 minutos" },
  },
  {
    icon: FileTextIcon,
    title: { en: "Custom Proposal", es: "Propuesta a Medida" },
    text: { en: "Receive a detailed, customized proposal with transparent pricing and service options.", es: "Reciba una propuesta detallada y personalizada con precios transparentes y opciones de servicio." },
    time: { en: "24–48 hours", es: "24–48 horas" },
  },
  {
    icon: GraduationCapIcon,
    title: { en: "Team Training", es: "Capacitación" },
    text: { en: "Our staff is trained specifically for your requirements and business standards.", es: "Nuestro personal se capacita específicamente según sus requisitos y estándares." },
    time: { en: "Before start date", es: "Antes del inicio" },
  },
  {
    icon: CircleCheckIcon,
    title: { en: "Service Delivery", es: "Prestación del Servicio" },
    text: { en: "Professional, reliable service with quality assurance and continuous support.", es: "Servicio profesional y confiable con control de calidad y apoyo continuo." },
    time: { en: "On schedule, every time", es: "A tiempo, siempre" },
  },
  {
    icon: StarIcon,
    title: { en: "Ongoing Support", es: "Apoyo Continuo" },
    text: { en: "Dedicated communication to ensure your satisfaction and adjust as your needs change.", es: "Comunicación dedicada para asegurar su satisfacción y ajustar según cambien sus necesidades." },
    time: { en: "Always available", es: "Siempre disponibles" },
  },
];
